<template>
 <div id="temupdate" v-if="dialogVisible">
        <div class="update_box">
            <div class="card">
                <div class="title" v-if="dialogdata.restrictOperate === 1">
                    <div class="subtilte">系统锁定</div>
                    <div class="time_title">预计到期时间：{{ dialogdata.endNotice ? getLocalTime(dialogdata.endNotice,
                        'haveSeconds') : "" }}</div>
                </div>
                <div class="title" v-else>
                    <div class="subtilte">系统更新</div>
                </div>
                <div class="content">
                    <el-scrollbar style="height: 100%;">
                        <div v-html="decodeURIComponent(dialogdata.content)"></div>
                    </el-scrollbar>
                </div>
                <div class="btns"
                    :style="{ left: !(dialogdata.path && dialogdata.restrictOperate !== 1) ? '520px' : '470px' }">
                    <div class="history" @click="seehistory" style="">历史公告</div>
                    <div class="to_view" @click="toPath"  v-if="dialogdata.path && dialogdata.restrictOperate !== 1">
                        去查看 <img src="/static/img/sys/update_go.png" alt="" style="width:14px;">
                    </div>
                </div>
            </div>
            <img class="close_icon" src="/static/img/sys/update_close.png" @click="cancel"
                v-if="dialogdata.restrictOperate !== 1" />
        </div>
    </div>
  <!-- <div id="temupdate">
    <el-dialog
      center
      top="10vh"
      :title="dialogdata.title"
      :close-on-click-modal="false"
      :close-on-press-escape='false'
      :visible.sync="dialogVisible"
      @close="cancel"
      width="1100px"
      :show-close="dialogdata.restrictOperate==1?false:true"
    >
      <div class="dialogNotice" v-loading="loadings" :element-loading-text="loadingText">
        <div class="locktips" v-if="dialogdata.restrictOperate==1">系统操作锁定中（结束时间：{{dialogdata.endNotice?getLocalTime(dialogdata.endNotice,'haveSeconds'):""}}）</div>
        <div style="margin-bottom: 20px;font-weight: bold;">{{dialogdata.summary}}</div>
        <div class="urlcontainer">
          <div v-html="decodeURIComponent(dialogdata.content)"></div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" class="minButton" @click="seehistory">查看历史公告</el-button>
      </div>
    </el-dialog>
  </div> -->
</template>

<script>
  import bus from '@/assets/utils/bus'
  import {getLocalTime} from '@/assets/utils/index'
  export default {
    props:['sysData'],
    data(){
      return {
        superMessage: false, 
        getLocalTime:getLocalTime,
        dialogVisible:false,
        loadings:false,
        loadingText:'查询中',
        dialogdata:{
          restrictOperate:'',
          endNotice:"",
          startNotice:'',
          title:'',
          summary:'',
          content:''
        },
        config: {
        	initialFrameWidth: 'auto',
        	initialFrameHeight:300
        },
        childData:{
          dialogVisible:false,
          detail:null,
          jug:''
        },
        status:''
      }
    },
    computed: {

    },
    created(){

      // bus.$on('showgongao',val=>{
      //   this.dialogVisible=true
      // })
    },
    methods:{
      seehistory(){//查看详情
        // this.dialogVisible=false
        bus.$emit('showhistory',true)
      },
      cancel(){
        if(this.superMessage) {
          this.superMessage = false;
          return 
        }
        if(this.dialogdata.restrictOperate==1){

        }else{
          let uid=JSON.parse(sessionStorage.getItem('user')).accountId
          this.$http.post('msg/notify/closeMsg', {noticeId:this.dialogdata.id,userId:uid},{form:'houtai'}).then(res=>{
          	if(res && res.data.code == 200) {
               this.dialogVisible=false
               this.$emit('sysclose')
          	}
          })
        }
      },

    },
    mounted() {

    },
    watch:{
      sysData: {
        handler(newName, oldName) {
          if(newName){
            this.$set(this.childData,'detail',newName)
            this.dialogdata=newName
            let date=new Date();
            let time=date.getTime()

            if((time>=newName.startNotice)&&(time<=newName.endNotice)){
              this.dialogVisible = true;
            }else{
              this.superMessage = true;
              this.dialogVisible=false
              // this.$emit('sysclose')
            }

          }else{
            this.dialogVisible=false
            // this.$emit('sysclose')
          }

        },
        deep:true,
        // immediate: true
      }
    }
  }
</script>
<style lang="less" scoped>
  #temupdate {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 2000;

    .update_box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 800px;
        height: 580px;

        .close_icon {
            position: absolute;
            top: -40px;
            right: 0;
            height: 40px;
            cursor: pointer;
        }

        .card {
            width: 800px;
            height: 540px;
            position: absolute;
            // top: 50%;
            // left: 50%;
            // transform: translate(-50%, -50%);
            background: #fff;
            overflow: hidden;
            background: url(/static/img/sys/update_card.png);
            background-size: 100% 100%;

            .title {
                position: absolute;
                color: #3658a0;
                font-size: 36px;
                font-style: normal;
                font-weight: bold;
                top: 50px;
                left: 40px;

                .time_title {
                    margin-top: 10px;
                    color: #ff5500;
                    font-size: 14px;
                    font-weight: bold;
                }
            }

            .content {
                position: absolute;
                top: 142px;
                left: 350px;
                width: 400px;
                height: 270px;
                border-radius: 10px;
                background: #ffffff80;
                backdrop-filter: blur(5px);
                padding: 20px;
                box-sizing: border-box;
            }

            .btns {
                display: flex;
                height: 40px;
                line-height: 40px;
                position: absolute;
                bottom: 63px;

                .history {
                    color: #269D7B;
                    font-size: 14px;
                    font-style: normal;
                    font-weight: bold;
                    cursor: pointer;
                }

                .to_view {
                    margin-left: 50px;
                    // padding: 0 27px;
                    // box-sizing: border-box;
                    // border-radius: 10px;
                    // background: #269D7B;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    column-gap: 10px;
                    color: #269D7B;
                    font-size: 14px;
                    cursor: pointer;
                }
            }


        }
    }
}
</style>
//  <style lang="less">
// //   #temupdate{
// //     .el-dialog__header{
// //       border-bottom: none !important;
// //     }
// //     .el-dialog__footer{
// //       border-top: none !important;
// //     }
// //   }
// // </style>
<style scoped>
  .dialogNotice .locktips{
    width: 100%;
    color: red;
    text-align: center;
    padding: 10px;
    padding-top: 0;
  }
  .dialogNotice .urlcontainer{
    box-sizing: border-box;
    padding: 20px;
    margin-top: 10px;
    height: 550px;
    overflow-y: auto;
    width: 100%;
    border: 1px solid #e0e0e0;
  }
  .urlcontainer >>> img{
    max-width: 100%;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .urlcontainer >>> video{
    max-width: 100%;
    display: block;
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/SystemUpdate.vue